var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#6FBCF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6,194.6c12.8,22.2,35.8,35.5,61.4,35.5c25.6,0,48.6-13.3,61.4-35.5c12.8-22.2,12.8-48.7,0-70.9     l-54-93.6c-3.3-5.7-11.5-5.7-14.8,0l-54,93.6C53.7,145.9,53.7,172.4,66.6,194.6L66.6,194.6z M112.8,74.6l11.5-20     c1.6-2.8,5.8-2.8,7.4,0l44.3,76.8c8.1,14.1,9.7,30.4,4.6,45.4c-0.5-2.4-1.3-4.9-2.3-7.4c-6.1-15.5-20-27.4-41.2-35.4     c-14.6-5.5-23.9-13.7-27.6-24.2C104.7,96.2,109.8,81.4,112.8,74.6L112.8,74.6z M93.1,108.6L80,131.4c-10,17.4-10,38.1,0,55.5     c10,17.4,28,27.7,48,27.7c13.3,0,25.7-4.6,35.5-12.7c1.3-3.2,5.2-14.9,0.3-27c-4.5-11.2-15.3-20.1-32.2-26.5     c-19-7.2-31.4-18.5-36.8-33.5C94.1,112.8,93.6,110.7,93.1,108.6z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "#FFFFFF",
    strokeWidth: 5.8052,
    strokeOpacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSui);
export default __webpack_public_path__ + "static/media/sui.b85d027fdc1c2245f68a2db3f26a5a32.svg";
export { ForwardRef as ReactComponent };